import {Component} from "../Component";
import {element} from "../CustomElement";
import {inject} from "../../services/di";
import {ConfigService, DistributionMode} from "../../services/ConfigService";
import {UserAgentService} from "../../services/UserAgentService";
import {StorageService} from "../../services/StorageService";
import {icons} from "../../icons/Icons";

interface IMobileBanner {
	whenWasHiddenName: string;
}

@element("mobile-banner")
export class MobileBanner extends Component<{}, {}> implements IMobileBanner {
	@inject config: ConfigService;
	@inject userAgent: UserAgentService;
	@inject storageService: StorageService;

	whenWasHiddenName = "when-was-hidden-mobile-banner";

	isBannerHidden() {
		const whenWasHidden = this.storageService.getItem(this.whenWasHiddenName);
		if (!this.userAgent.mobile || this.config.DISTRIBUTION_MODE !== DistributionMode.NONE) {
			return true;
		}
		if (whenWasHidden === null) {
			return false;
		}
		return Math.abs((new Date()).getTime() - parseInt(whenWasHidden)) <= 864e5;
	}

	isAppInstalled() {
		return false;
	}

	getLinkTitle() {
		return this.userAgent.iOS ? "Flipp for iPhone" : "Flipp for Android";
	}

	getLinkButtonText() {
		return this.isAppInstalled() ? "Open" : "Get App";
	}

	hideBanner() {
		this.storageService.setItem(this.whenWasHiddenName, (new Date()).getTime().toString());
		this.invalidate();
	}

	render() {
		if (this.isBannerHidden()) {
			return null;
		}
		return <div class="mobile-banner">
				<div class="mobile-banner__close" onClick={this.hideBanner.bind(this)}>
					<div>
						<img class="myCloseIcon" src="https://f.wishabi.net/creative/Distribution/images/icons/myCloseIcon.svg" alt=""/>
					</div>
				</div>
				<div class="mobile-banner__logo">
					<div>
						<img class="myFlippIcon" src="https://f.wishabi.net/creative/Distribution/images/icons/myFlippIcon.svg" alt=""/>
					</div>
				</div>
				<div class="mobile-banner__links">
					<div class="mobile-banner__links__title">{this.getLinkTitle()}</div>
					<div class="mobile-banner__links__body">
						Everything you love about Flipp available in our App
					</div>
					<div class="mobile-banner__links__button">
						<a href="https://flipp.app.link/KYJFGWvFo1">{this.getLinkButtonText()}</a>
					</div>
				</div>
			</div>;
	}
}
